export const onlyLettersAndNumbersRegex = (str: string) => {
    return /^[A-Za-z0-9]*$/.test(str);
};

export const spliteStringPerLine = (str: string) => str.split(/\r?\n|\r|\n/g);
